import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.714 8.1c0-4.265 3.582-6.769 6.796-6.769 2.301 0 4.445.866 5.596 2.867l-2.149 1.251a4.04 4.04 0 0 0-3.402-1.813c-1.891 0-4.14 1.485-4.14 4.422 0 2.866 2.148 4.447 4.317 4.447 1.507 0 2.76-.846 3.5-2.148l2.197 1.018c-1.243 2.249-3.467 3.446-6.045 3.446-3.246-.003-6.67-2.511-6.67-6.721"
    }, null, -1)
  ]))]))
}
export default { render: render }